import React from 'react';
import { useTranslation } from 'react-i18next';
import { getPasswordStrength } from '@lib/password';

interface PasswordStrengthMeterProps {
  password: string;
}

const PasswordStrengthMeter: React.FC<PasswordStrengthMeterProps> = ({ password }) => {
  const { t } = useTranslation();
  const strength = getPasswordStrength(password);
  if (strength === 'empty') return null;

  const isStrong = strength === 'strong';

  return (
    <div className="mt-2">
      <div className="flex justify-between text-xs">
        <span>{t('password.strength')}</span>
        <span className={isStrong ? 'text-success' : 'text-destructive'}>
          {isStrong ? t('password.strong') : t('password.weak')}
        </span>
      </div>
      <div className="mt-1 h-2 bg-secondary rounded-full">
        <div
          className={`h-full rounded-full transition-all ${
            isStrong ? 'bg-success w-full' : 'bg-destructive w-1/3'
          }`}
        />
      </div>
    </div>
  );
};

export default PasswordStrengthMeter;
